import { render, staticRenderFns } from "./OverviewPieCharts.vue?vue&type=template&id=e5f1840c&scoped=true&"
import script from "./OverviewPieCharts.vue?vue&type=script&lang=js&"
export * from "./OverviewPieCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f1840c",
  null
  
)

export default component.exports